import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { Invitation, InvitationId, CreateInvitationDTO, OrganisationId, InvitationConfirmation } from '@portal-front-end/models';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class InvitationsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly INVITATION_API_URL = `${this.apiServer}/invitation`;

    getInvitations(organisationId: OrganisationId): Observable<Invitation[]> {
        return this.http.get<Invitation[]>(`${this.INVITATION_API_URL}/organisation/${organisationId}`);
    }

    createInvitation(invite: CreateInvitationDTO): Observable<Invitation> {
        return this.http.post<Invitation>(`${this.INVITATION_API_URL}/`, invite);
    }

    getInvitationById(invitationId: InvitationId): Observable<Invitation> {
        return this.http.get<Invitation>(`${this.INVITATION_API_URL}/${invitationId}`);
    }

    getInvitationValidity(invitationId: InvitationId): Observable<boolean> {
        return this.http.get<boolean>(`${this.INVITATION_API_URL}/${invitationId}/is-valid`);
    }

    resendInvitation(invitationId: InvitationId): Observable<Invitation> {
        return this.http.post<Invitation>(`${this.INVITATION_API_URL}/resend-invite/${invitationId}`, null);
    }

}
